import { adminHttpClient } from "../../../../commons/adminHttpClinet";
import { UpdateMarketplaceOrderModel } from "../../../../models/dashboard/marketplace/marketplaceCategoryModel";

const updateOrderCategories = (model: Array<UpdateMarketplaceOrderModel>) : Promise<any> => {
    return adminHttpClient.put("/api/Admin/AdminMarketplace/order-category", model);
};

export  default updateOrderCategories;